"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionModelVizCardButton = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var styles = require("../styles/PredictionModelResultsViz");
var TestIds_1 = require("../util/TestIds");
var PredictionModelVizCardButton = function (props) {
    var label = props.label, onClick = props.onClick;
    return (React.createElement(widgets_1.ButtonWidget, { className: styles.cardButton, buttonType: widgets_1.ButtonType.LowEmphasis, onClick: onClick, testId: TestIds_1.PredictionModelVizCardButtonId }, label));
};
exports.PredictionModelVizCardButton = PredictionModelVizCardButton;
//# sourceMappingURL=PredictionModelVizCardButton.js.map